<template>
  <div class="container">
    <div class="white-frame">
      <div class="title-text mb-3"><b>Pesquisa Apólice</b></div>
      <div class="row g-3 pb-3">
        <div
          class="col-md-6"
          :class="{
            'field-required': validation.Sinistro.SinistroData.$invalid,
          }"
        >
          <label for="data_sinistro" class="form-label">Data Sinistro</label>
          <Calendar
            id="data_sinistro"
            v-model="sinistro.SinistroData"
            dateFormat="dd/mm/yy"
            selectionMode="single"
            :showOnFocus="false"
            :showIcon="true"
            :manualInput="true"
            :maxDate="maxDate"
            placeholder="dd/mm/aaaa"
            class="form-control p-0"
          />
        </div>
        <!-- <input type="text" v-imask="mask" /> -->
        <div
          class="col-md-6"
          :class="{
            'field-required': $v.apolicePesquisa.$invalid,
          }"
        >
          <label for="apolice" class="form-label"
            >Apólice/Bilhete/Certificado</label
          >
          <imask-input
            id="apolice"
            v-model="apolicePesquisa"
            :mask="apoliceBilheteMask"
            :unmask="false"            
            class="form-control"
          />
        </div>
      </div>
      <div
        class="col-12 Aligner aligner-right"
        v-if="
          !validation.Sinistro.SinistroData.$invalid &&
            !validation.SeguradoContacto.$invalid &&
            !validation.ComunicanteContacto.$invalid &&
            !validation.Servico.$invalid &&
            !$v.apolicePesquisa.$invalid
        "
      >
        <button
          @click="getPolicy"
          :disabled="loadingPolicies"
          class="button-base-small btn-blue font-small"
        >
          <i v-if="loadingPolicies" class="fa fa-spinner"></i>
          {{ loadingPolicies ? 'Aguarde...' : 'Pesquisar' }}
        </button>
      </div>

      <Message v-if="showPolicyCancelledButDateOfClaimValid" severity="warn">
        Atenção, A pesquisa teve o retorno de apólice cancelada
      </Message>

      <Message v-if="showPoliciesError" severity="error">
        Não foi possível localizar uma apólice com os dados informados.
        Verifique se as informações inseridas estão corretas, caso o erro
        persista e precise de mais informações entre em contato com a nossa
        central nos telefones: 3003 9309 (capitais e regiões metropolitanas) -
        0800 292 4357 (demais localidades).
      </Message>

      <div class="title-text mb-3"
           v-if="policies !== null && policies.length !== 0">
    
          <b>Selecionar Apólice</b>

      </div>
      <div
        class="custom-card-grid-4x4"
        v-if="policies !== null && policies.length !== 0"
      >
        <div
          v-for="(policy, i) in policies"
          :key="i"
          class="custom-card mob-w100"
          @click="selectPolicy(policy)"
        >
          <div class="px-4 py-3">
            <div class="c-card-Title">
              {{ policy.BilheteNr ? policy.BilheteNr : policy.ApoliceNr }}
            </div>
            <div class="c-card-descr">
              <p>{{ policy.ProductName }}</p>
              <p>
                ({{ policy.ApoliceDataInicio }} - {{ policy.ApoliceDataFim }})
              </p>
              <div v-for="ins in policy.InsuranceObjects" :key="ins.Marca">
                <p>{{ ins.Marca }} - {{ ins.Modelo }}</p>
              </div>
            </div>
            <!-- <button
              
              class="btn-blue button-base button-base-small mt-2"
            >
              Selecionar
            </button>-->
          </div>

          <!-- <Card>
            <template #title>
              {{ policy.ApoliceNr }}
            </template>
            <template #content>
              <p>
                ({{ policy.ApoliceDataInicio }} - {{ policy.ApoliceDataFim }})
              </p>
              <div v-for="ins in policy.InsuranceObjects" :key="ins.Marca">
                <p>{{ ins.Marca }} - {{ ins.Modelo }}</p>
              </div>
            </template>
            <template #footer>
              <Button label="Selecionar" @click="selectPolicy(policy)" />
            </template>
          </Card>-->
        </div>

        <!-- <div>
        <div v-for="(policy, i) in a" :key="i">
          <p>{{ policy.ApoliceDataInicio }}</p>
          ||
          <p>{{ policy.ApoliceDataFim }}</p>
          ||
          <p>{{ policy.OperationPK }}</p>
          <div v-for="ins in policy.InsuranceObjects" :key="ins.Marca">
            <p>{{ ins.Marca }}</p>
            ||
            <p>{{ ins.Modelo }}</p>
          </div>
        </div>
        </div>-->
      </div>
      <div ref="refPolicy"></div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(utc);
dayjs.extend(customParseFormat);
import { IMaskComponent } from 'vue-imask';
import { GetPolicies } from '../api/formMethods';
import VueScrollTo from 'vue-scrollto';
import { inputClean } from '../utils/customValidations';


export default {   
  components: {
    "imask-input": IMaskComponent,
  }, 
  data() {
    return {
      maxDate: new Date(),
      apolicePesquisa: '',
      policies: [],
      loadingPolicies: false,
      showPoliciesError: false,
      showPolicyCancelledButDateOfClaimValid: false,
      mask: {
        mask: '00/00/0000',
        lazy: false,
      },
      dateMask: {
        mask: '000.000.000-00',
      },
      apoliceBilheteMask: [
        {mask: "00000000000000000000000"},
        {mask: "00000.0000.0000.0000.0000000"},
        {mask: "00000.0000.0000.0000.0000000-0000000"},
        {mask: "00000.0000.0000.0000.0000000-00000000"},
        {mask: "00000.0000.0000.0000.0000000-000000000"},
        {mask: "00000.0000.0000.0000.0000000-0000000000"},
        {mask: "00000.0000.0000.0000.0000000-00000000000"},
        {mask: "00000.0000.0000.0000.0000000-000000000000"},
        {mask: "00000.0000.0000.0000.0000000-0000000000000"},
        {mask: "00000.0000.0000.0000.0000000-00000000000000"},
        {mask: "00000.0000.0000.0000.0000000-000000000000000"},
        {mask: "00000.0000.0000.0000.0000000-0000000000000000"}
      ]
    };
  },
  validations: {
    apolicePesquisa: { inputClean },
  },
  props: {
    apolice: Object,
    sinistro: Object,
    validation: Object,
    seguradoCpf: String,
  },
  methods: {    
    async getPolicy() {
      try {
        this.loadingPolicies = true;
        this.showPoliciesError = false;
        this.showPolicyCancelledButDateOfClaimValid = false;
        this.policies = [];
        this.policies = await GetPolicies(
          this.apolicePesquisa,
          this.seguradoCpf,
          dayjs(this.sinistro.SinistroData)
            .local()
            .format()
          // this.$route.params.ids
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingPolicies = false;
        if (this.policies == null || this.policies.length === 0) {
          this.showPoliciesError = true;
        }

        if (this.policies.some((x) => x.CancelledButDateOfClaimValid == true)) {
          this.showPolicyCancelledButDateOfClaimValid = true;
        }

        // var cont = this.$refs.refPolicy;
        VueScrollTo.scrollTo(this.$refs.refPolicy);
      }
    },
    selectPolicy(policy) {
      // const {
      //   ApoliceDataFim,
      //   ApoliceDataInicio,
      //   ApoliceNr,
      //   ApoliceId,
      //   GisRamoId,
      //   GisProdutoId,
      //   OperationPK,
      // } = policy;
      // this.apolice.ApoliceNr = ApoliceNr.replace(".", "");
      // this.apolice.ApoliceDataInicio = dayjs(ApoliceDataInicio, "DD/MM/YYYY");
      // this.apolice.ApoliceDataFim = dayjs(ApoliceDataFim, "DD/MM/YYYY");
      // this.apolice.ApoliceProdutoId = GisProdutoId;
      // this.apolice.ApoliceContrato = OperationPK;
      // this.apolice.ApoliceExternalId = ApoliceId;
      // this.sinistro.SinistroRamoId = GisRamoId;
      this.$emit('selected', policy);
    },
  },
};
</script>
